import { Component, inject } from '@angular/core';
import { EnvironmentService } from '../../../core/services/environment.service';

/** Badge de ambiente (Produção/Homologação/Desenvolvimento) — sempre derivado de ApiConfigService, nunca fixo. */
@Component({
  selector: 'app-environment-badge',
  standalone: true,
  imports: [],
  templateUrl: './environment-badge.component.html',
  styleUrl: './environment-badge.component.scss',
})
export class EnvironmentBadgeComponent {
  private readonly environmentService = inject(EnvironmentService);

  readonly environment = this.environmentService.current;
}
